import { render, staticRenderFns } from "./vNutritionLabelFSIS.vue?vue&type=template&id=507895bc&scoped=true"
import script from "./vNutritionLabelFSIS.vue?vue&type=script&lang=ts"
export * from "./vNutritionLabelFSIS.vue?vue&type=script&lang=ts"
import style0 from "./vNutritionLabelFSIS.vue?vue&type=style&index=0&id=507895bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507895bc",
  null
  
)

export default component.exports